//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// ### STYLES ###
import { Box, TextField, Button, Link } from '@mui/material';

// === API ===
import { prokeyApi } from 'api';

//#endregion

//-----------------------------------------------------------------
export function RequestForm( ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate = useNavigate();
  
  const [ name       , setName      ] = useState( '' );
  const [ company    , setCompany   ] = useState( '' );
  const [ email      , setEmail     ] = useState( '' );
  const [ comments   , setComments  ] = useState( '' );
  const [ alert_info , setAlertInfo ] = useState({ style: [], message: '' });

  const error_message_default = 'Access Request failed, send us an email at sales@paradatec.com, or call us at 1-513-583-1382';
  const email_regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);

  //#endregion

  //#region [STYLES]

  const _styles = {
    alert: {
      display          : 'inline-block',
      color            : 'white',
      marginTop        : '1rem',
      padding          : '1rem',
      width            : '100%',
      borderRadius     : '4px',
    },
    hidden: {
      display: 'none',
    },
    failure: {
      backgroundColor: 'darkred',
    },
    success: {
      backgroundColor: 'darkgreen',
    },

    email: {
      width  : '100%'   ,
      margin : '0.5rem' ,
    },

    sign_in_container: {      
      width     : '100%'         ,
      marginTop : '0.75rem'      ,
      display   : 'inline-block' ,
    },
    REQUEST_ACCESS_BUTTON: {
      marginLeft: '1rem',
    }
  }

  // === PROPS ===

  const _props = {
    ALERT: {
      sx: alert_info.style,
      children: [alert_info.message]
    },

    NAME: {
      name       : 'name_txt',
      type       : 'text'           ,
      variant    : 'filled'         ,
      sx         : _styles.email    ,
      label      : 'Name (required)' ,
      value      : name             ,
      autoFocus  : true             ,
      onFocus    : clearAlert       ,
      onKeyPress : handleKeyPress   ,
      onChange   : (e) => setName(e.target.value),
    },
    COMPANY: {
      name       : 'company_txt',
      type       : 'text'           ,
      variant    : 'filled'         ,
      sx         : _styles.email    ,
      label      : 'Company (required)' ,
      value      : company          ,
      autoFocus  : true             ,
      onFocus    : clearAlert       ,
      onKeyPress : handleKeyPress   ,
      onChange   : (e) => setCompany(e.target.value),
    },
    EMAIL: {
      name       : 'email_txt',
      type       : 'text'           ,
      variant    : 'filled'         ,
      sx         : _styles.email    ,
      label      : 'Email (required)' ,
      value      : email            ,
      autoFocus  : true             ,
      onFocus    : clearAlert       ,
      onKeyPress : handleKeyPress   ,
      onChange   : (e) => setEmail(e.target.value),
    },
    COMMENTS: {
      name       : 'comments_txt',
      type       : 'text'           ,
      variant    : 'filled'         ,
      sx         : _styles.email    ,
      label      : 'Comments (optional)' ,
      value      : comments         ,
      autoFocus  : true             ,
      onFocus    : clearAlert       ,
      onKeyPress : handleKeyPress   ,
      onChange   : (e) => setComments(e.target.value),
    },

    GO_BACK_LINK: {
      name      : 'go_back_link',
      component : 'button',
      onClick   : handleGoBack,
      children  : ['Back to login'],
    },
    REQUEST_ACCESS_BUTTON: {
      name      : 'request_access_btn',
      sx       : _styles.REQUEST_ACCESS_BUTTON,
      variant  : 'contained'    ,
      color    : 'primary'      ,
      onClick  : postRequest    ,
      children : ['Request Access!'] ,
    }
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  async function postRequest() {
    //-----------------------------------------------------------------
    try {
      clearAlert();

      if ( !name || !company || !email ) {
        setAlertInfo({ style: [_styles.alert, _styles.failure], message: 'Name, Company, and Email are all required' });
        return;
      } 
      
      if ( !email_regex.test( email ) ) {
        setAlertInfo({ style: [_styles.alert, _styles.failure], message: 'Please provide a valid email address' });
        return;
      }

      const request_info = { name, company, email, comments };
      const result = await prokeyApi.postRequestAccess(request_info);

      if( result.status !== 200 ) throw result.status;

      // Success! Provide some nice feedback!!!
      const message = "Request Submitted! You'll be returned to the login screen shortly";
      setAlertInfo( { style: [_styles.alert, _styles.failure], message } );
      setTimeout( handleGoBack, 10000 );

    } catch (error) {
      setAlertInfo( { style: [_styles.alert, _styles.failure], message: error_message_default } );
    }
  }

  //-----------------------------------------------------------------
  async function handleKeyPress(target) {
    //-----------------------------------------------------------------
    if (target.charCode === 13) postRequest();
  }

  //-----------------------------------------------------------------
  async function handleGoBack() {
    //-----------------------------------------------------------------
    navigate( '../' );
  }

  //-----------------------------------------------------------------
  async function clearAlert() {
    //-----------------------------------------------------------------
    setAlertInfo( {style: [_styles.hidden], message: ''} );
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() { // Request Access!
    //-----------------------------------------------------------------
    return (
      <Box sx={ _styles.container }>
        <TextField { ..._props.NAME     } />
        <TextField { ..._props.COMPANY  } />
        <TextField { ..._props.EMAIL    } />
        <TextField { ..._props.COMMENTS } />
        <Box sx={ _styles.sign_in_container }>
          <Link {..._props.GO_BACK_LINK}  />
          <Button {..._props.REQUEST_ACCESS_BUTTON } />
        </Box>
        <Box {..._props.ALERT}/>
      </Box>
    )
  }

  //#endregion

  return display();
}
